<template>
    <div class="demand-details demand-details-card mb-1">
        <b-row class="route-section" v-if="subTitle">
            <b-col cols="12" class="ft-route-details small-text text-grey-1 mb-1">
                <card-subtitle :data="cardSubtitleText" />
            </b-col>
        </b-row>
        <b-row class="route-section">
            <b-col cols="10" class="ft-route-details">
                <origin-destination-label :origin="data.origin" :destination="data.destination" />
            </b-col>
            <b-col cols="2" class="ft-share-button mt-2" v-if="shareOption">
                <share-button @on-click="handleOnClickShare"/>
            </b-col>
        </b-row>
        
        <vehicle-detail :truckType="truckTypeWithQty"/>

        <b-row class="mt-3">
            <b-col cols="12">
                <b-button block variant="outline-secondary" class="ft-btn-block text-uppercase" @click="handleAddLoad">{{btnText}}</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CardSubtitle from './UI/CardSubtitle.vue'
import OriginDestinationLabel from './UI/OriginDestinationLabel.vue'
import VehicleDetail from './UI/VehicleDetail.vue'
import ShareButton from './ShareButton.vue'
import {relativeTime} from '../util/commonUtil'


export default {
    name: "DemandDetailCard",
    props: {
        data: [Array, Object],
        btnText: String,
        subTitle: String,
        shareOption: [Boolean, String],
        _type: String
    },
    components: {
        CardSubtitle,
        OriginDestinationLabel,
        VehicleDetail,
        ShareButton
    },
    computed: {
        truckTypeWithQty() {
            return `${this.data.required_no_of_trucks} x  ${this.data.truck_type}`
        },
        cardSubtitleText() {
            // return ''
            return `ID ${this.data.id} • Created ${relativeTime(this.data.created_at)}`
        }
    },
    methods: {
        handleAddLoad() {
            const load = {...this.data}
            load._type = this.btnText == "Quick Add" ? 'supply' : 'load'
            this.$store.commit('setLspLoadDetail', load)
            this.$router.push({ name: 'lsp_add', params: { lang: this.$route.params.lang, id: this.$route.params.id  } })
        },
        handleOnClickShare() {
            this.$emit('share-action', this.data)
        }
    }
}
</script>

<style lang="scss">
.demand-details-card {
    background-color: #fff;
    padding: 1rem;
    padding-bottom: 1rem;
}
.ft-btn-block {
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.75px;
    color: #1F1F1F;
}
</style>